import { render } from "./RockHeaderLang.vue?vue&type=template&id=240a546a&scoped=true"
import script from "./RockHeaderLang.vue?vue&type=script&lang=js"
export * from "./RockHeaderLang.vue?vue&type=script&lang=js"

import "./RockHeaderLang.vue?vue&type=style&index=0&id=240a546a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240a546a"]])

export default __exports__